export enum DocumentStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
}
